import {
  DollarCircleOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

// Payment Status Options
export const PAYMENT_STATUS_OPTIONS = [
  { label: 'Unpaid', value: 'UNPAID' },
  { label: 'Paid', value: 'PAID' },
  { label: 'Partially Paid', value: 'PARTIALLY_PAID' },
  { label: 'Cancelled', value: 'CANCELLED' },
];

// Filter Options
export const PAYMENT_STATUS_FILTER_OPTIONS = PAYMENT_STATUS_OPTIONS;

// Payment Status Colors
export const PAYMENT_STATUS_COLORS = {
  UNPAID: 'orange',
  PAID: 'green',
  PARTIALLY_PAID: 'blue',
  CANCELLED: 'red',
} as const;

// Payment Status Icons
export const PAYMENT_STATUS_ICONS = {
  UNPAID: <DollarCircleOutlined />,
  PAID: <CheckOutlined />,
  PARTIALLY_PAID: <ExclamationCircleOutlined />,
  CANCELLED: <CloseCircleOutlined />,
} as const;
